/** A known racing track with its map center location */
export interface TrackInfo {
  id: string;
  name: string;
  location: string;
  center: { lat: number; lng: number };
  zoom: number;
}

interface TracksData {
  tracks: TrackInfo[];
}

let _cache: TrackInfo[] | null = null;

/** Load the tracks list from the bundled JSON file. Caches after first load. */
export async function loadTracks(): Promise<TrackInfo[]> {
  if (_cache) return _cache;
  const resp = await fetch("/tracks.json");
  if (!resp.ok) {
    console.error("Failed to load tracks.json:", resp.status);
    return [];
  }
  const data: TracksData = await resp.json();
  _cache = data.tracks;
  return _cache;
}
